import { TableRawMeta } from '@pricemoov/formula-engine';

export enum View {
    PRICES = 'prices',
    ASSORTMENTS = 'assortments',
    INDEXATIONS = 'indexations',
    CORRIDORS = 'corridors',
    CHAINING = 'chaining',
    STRATEGY = 'strategy',
    PROMOTIONS = 'promotions',
    CLIENTS = 'clients',
    SEGMENTS = 'segments',
    AGREEMENTS = 'agreements',
    NEW_AGREEMENTS = 'new_agreements',
    PROMOTIONS_REWORK = 'promotions_rework',
    CLIENT_AGREEMENTS = 'client_agreements',
    CLIENT_AFFILIATES = 'client_affiliates',
    AGREEMENT_PRICES = 'agreement_prices',
    AGREEMENT_PRICE_LISTS = 'agreement_price_lists',
    PRICELIST = 'price_list',
    PROMOTIONS_TABLE = 'promotions_table',
    EDIT_PRICE_LIST = 'edit_price_list',
    EDIT_PRICE_LIST_PRODUCT_CATALOG = 'edit_price_list_product_catalog',
    COEFFICIENT_TABLE = 'coefficient-table',
    PERMISSIONS_VIEW = 'permissions-table',
    INTEGRATIONS = 'integrations',
    PRODUCT_CATALOG = 'product-catalog',
    PRODUCT_CATALOG_SCHEMA_CONFIGURATION = 'product-catalog-schema-configuration',
    SETTINGS_PERMISSIONS = 'settings-permissions',
    ELASTICITY = 'elasticity',
    CPI_FORMULAS = 'cpi-formulas',
    ROUNDING_RULES = 'rounding_rules',
}

export enum NamedColumns {
    // Common columns
    CHECKBOX = 'checkbox',
    LOGO = 'logo',
    CODENAME = 'codename',
    GROUP = 'group',
    PIVOT = 'pivot',

    // Details
    PRICE = 'price',
    STRATEGY = 'strategy',
    MIN_PRICE = 'min_price',
    MAX_PRICE = 'max_price',
    BUYBOX = 'buybox',
    FULFILLMENT = 'fulfillment',
    STOCK = 'stock',
    VOLUME = 'volume',
    REVENUE = 'revenue',
    MARGIN = 'margin',
    // Rental
    AVERAGE_PRICE = 'average_price',
    OCCUPANCY_RATE = 'occupancy_rate',
    REVPAR = 'revpar',

    // Forecast
    FORECASTED_REVENUE_7 = 'FORECASTED_REVENUE_7',
    FORECASTED_VOLUME_7 = 'FORECASTED_VOLUME_7',
    FORECASTED_REVENUE_28 = 'FORECASTED_REVENUE_28',
    FORECASTED_VOLUME_28 = 'FORECASTED_VOLUME_28',
    STOCK_OUT_DATE = 'STOCK_OUT_DATE',

    // GBH
    YIELD_COEF = 'yield_coef',
    SEGMENT = 'segment',
    SIPP = 'SIPP',

    // Kiloutou
    TRANCHE_1 = 'TRANCHE_1',
    TRANCHE_2 = 'TRANCHE_2',
    TRANCHE_3 = 'TRANCHE_3',
    TRANCHE_4 = 'TRANCHE_4',
    TRANCHE_5 = 'TRANCHE_5',
    MONTHLY = 'MONTHLY',
}

export enum Filter {
    HIDE_COLUMNS = 'hide_columns',
    CATEGORY = 'category',
    BUYBOX = 'buybox',
    HOURS_BUYBOX_LOST = 'hours_buybox_lost',
    STRATEGIES = 'strategies',
    ORDERING = 'ordering',
    FULFILLMENT = 'fulfillment',
    COST = 'cost',
    PRICING_ZONES = 'pricing_zones',
    STOCK = 'stock',
    SEARCH = 'search',
    CONDITION = 'condition',
    AGENCY = 'agency',
    PRODUCT = 'product',
    HOURS_WITHOUT_CHANGES = 'hours_without_changes',

    // GBH
    PERIOD = 'period__number',
    TARIFF = 'tariff',
    DURATION_RANGE = 'duration_range',
    VEHICLE_SIPP = 'vehicle__SIPP',
    GBH_ZONE = 'gbh_zone',
}

export enum LoginPreviews {
    COMPETITORS = 'preview_competitors',
    STRATEGIES = 'preview_strategies',
    PERFORMANCES = 'preview_performances',
}

export enum ColumnType {
    STR = 'STR',
    PRICES_VIEW_RULES = 'PRICES_VIEW_RULES',
    PRICES_VIEW_GUIDELINES = 'PRICES_VIEW_GUIDELINES',
    PRICES_VIEW_CORRIDORS = 'PRICES_VIEW_CORRIDORS',
    ACTIVATION_PERIOD = 'ACTIVATION_PERIOD',
    PRICE_LIST_INFO = 'PRICE_LIST_INFO',
    MINMAX = 'MIN_MAX',
    INT = 'INT',
    BIGINT = 'BIGINT',
    FLOAT = 'FLOAT',
    CUSTOM = 'CUSTOM',
    CUSTOM_DATED = 'CUSTOM_DATED',
    STRATEGY_PARAM = 'STRATEGY_PARAM',
    PRICE = 'PRICE',
    COMPETITORS = 'COMPETITORS',
    CPI = 'CPI',
    PRICES_VIEW_PRICE = 'PRICES_VIEW_PRICE',
    PRICES_VIEW_EXTERNAL_PRICE_LIST_PRICE = 'EXTERNAL_PRICE_LIST_PRICE',
    PRICES_VIEW_PRICE_ARRAY = 'PRICES_VIEW_PRICE_ARRAY',
    PRICES_VIEW_KPI_VOLUME = 'PRICES_VIEW_KPI_VOLUME',
    PRICES_VIEW_KPI_REVENUE = 'PRICES_VIEW_KPI_REVENUE',
    PRICES_VIEW_KPI_REVENUE_RECOMMENDED = 'PRICES_VIEW_KPI_REVENUE_RECOMMENDED',
    PRICES_VIEW_KPI_REVENUE_VARIATION = 'PRICES_VIEW_KPI_REVENUE_VARIATION',
    PRICES_VIEW_KPI_GROSS_MARGIN = 'PRICES_VIEW_KPI_GROSS_MARGIN',
    PRICES_VIEW_KPI_GROSS_PROFIT = 'PRICES_VIEW_KPI_GROSS_PROFIT',
    DATETIME = 'DATETIME',
    TIMESTAMP = 'TIMESTAMP',
    DATE = 'DATE',
    PROMOTION_INFO_ARRAY = 'PROMOTION_INFO_ARRAY',
    PROMOTION_INFO = 'PROMOTION_INFO',
    PROMOTION_PRICE = 'PROMOTION_PRICE',
    PROMOTION_REFERENCE_PRICE_INFO = 'PROMOTION_REFERENCE_PRICE_INFO',
    PROMOTION_PRICE_INFO = 'PROMOTION_PRICE_INFO',
    PROMOTION_VARIATION = 'PROMOTION_VARIATION',
    NAMED_COLUMN = 'NAMED_COLUMN',
    KILOUTOU_PRICING = 'KILOUTOU_PRICING',
    ADV_CONTRIB_PER_TEU_COLUMN = 'ADV_CONTRIB_PER_TEU_COLUMN',
    GENERIC_COLUMN = 'GENERIC_COLUMN',
    PERCENTAGE_COLUMN = 'PERCENTAGE_COLUMN',
    PERCENTAGE_ALERT_COLUMN = 'PERCENTAGE_ALERT_COLUMN',
    POSITIVE_NEGATIVE_COLUMN = 'POSITIVE_NEGATIVE_COLUMN',
    PRICE_ARRAY_SUB_TABLE_ACTIVE_PRICE = 'PRICE_ARRAY_SUB_TABLE_ACTIVE_PRICE',
    PRICE_ARRAY_SUB_TABLE_COMPETITORS = 'PRICE_ARRAY_SUB_TABLE_COMPETITORS',
    PRICE_ARRAY_SUB_TABLE_CPI = 'PRICE_ARRAY_SUB_TABLE_CPI',
    PRICE_ARRAY_SUB_TABLE_GUIDELINES = 'PRICE_ARRAY_SUB_TABLE_GUIDELINES',
    SEGMENT = 'SEGMENT',
    DIFF_COLUMN = 'DIFF_COLUMN',
    PRICE_COLUMN = 'PRICE_COLUMN',
    REGULAR_COLUMN = 'REGULAR_COLUMN',
    NUMERIC_COLUMN = 'NUMERIC_COLUMN',
    REGULAR_SPLIT = 'REGULAR_SPLIT',
    ACTIONS_COLUMN = 'ACTIONS_COLUMN',
    STRATEGY_COLUMN = 'STRATEGY_COLUMN',
    EDITABLE_PRICE_COLUMN = 'EDITABLE_CELL_COLUMN',
    MODAL_PRICE_COLUMN = 'MODAL_PRICE_COLUMN',
    CHECKMARK_COLUMN = 'CHECKMARK_COLUMN',
    DOUBLE_CHEKMARK_COLUMN = 'DOUBLE_CHEKMARK_COLUMN',
    DATE_COLUMN = 'DATE_COLUMN',
    VALUE_NAME_COLUMN = 'VALUE_NAME_COLUMN',
    COMPETITORS_COLUMN = 'COMPETITORS_COLUMN',
    TOOLTIP_COLUMN = 'TOOLTIP_COLUMN',
    PRICE_LIST_NAME_COLUMN = 'PRICE_LIST_NAME_COLUMN',
    PRICELIST_STATUS = 'PRICELIST_STATUS',
    PIVOT = 'PIVOT',
    GROUP = 'GROUP',
    BUNDLE_DETAILS = 'BUNDLE_DETAILS',
    AGREEMENT_PRICE_LISTS_DEFAULT_DISCOUNT = 'AGREEMENT_PRICE_LISTS_DEFAULT_DISCOUNT',
    AGREEMENT_PRICE_LISTS_ACTIONS = 'AGREEMENT_PRICE_LISTS_ACTIONS',
    AGREEMENT_PRICELIST_INFO = 'AGREEMENT_PRICELIST_INFO',
    AGREEMENT_PRICELIST_SIMULATION_KPI = 'AGREEMENT_PRICELIST_SIMULATION_KPI',
    AGREEMENT_PRICELIST_TRANSACTIONS_KPI = 'AGREEMENT_PRICELIST_TRANSACTIONS_KPI',
    AGREEMENT_PRICELIST_INFO_ARRAY = 'AGREEMENT_PRICELIST_INFO_ARRAY',
    IS_PIVOT = 'IS_PIVOT',
    ID = 'ID',
    BOOLEAN = 'BOOLEAN',
    PRICES_PROMOTION = 'PRICES_PROMOTION',
    // TODO: remove this type (BE should return a BOOLEAN type)
    BOOL = 'BOOL',
    COST = 'COST',
    ACTIVE = 'ACTIVE',
    ACTIVE_PRICE = 'ACTIVE_PRICE',
    COLUMN_FORMULA = 'COLUMN_FORMULA',
    TAGS = 'TAGS',
    ARRAY_STR = 'ARRAY_STR',
    PRICE_LIST_REVENUE_KPI = 'PRICE_LIST_REVENUE_KPI',
    PRICE_LIST_MARGIN_KPI = 'PRICE_LIST_MARGIN_KPI',
    PRICE_LIST_CPI_KPI = 'PRICE_LIST_CPI_KPI',
    MARGIN = 'MARGIN',
    MARGIN_IMPACT = 'MARGIN_IMPACT',
    TARGET_MARGIN = 'TARGET_MARGIN',
    OBJECT_ARRAY = 'OBJECT_ARRAY',
    SEGMENTS_ACTIONS = 'SEGMENTS_ACTIONS',
    ROUNDING_RULES_ACTIONS = 'ROUNDING_RULES_ACTIONS',
    // Indexations
    INDEXATION_GROUPS = 'INDEXATION_GROUPS',
    INDEXATION_NAME = 'INDEXATION_NAME',
    INDEXATION_FORMULA = 'INDEXATION_FORMULA',
    INDEXATION_ASSORTMENT = 'INDEXATION_ASSORTMENT',
    // Corridors
    CORRIDOR_PRICE_LISTS = 'CORRIDOR_PRICE_LISTS',
    CORRIDOR_NAME = 'CORRIDOR_NAME',
    CORRIDOR_FORMULA_MIN = 'CORRIDOR_FORMULA_MIN',
    CORRIDOR_FORMULA_MAX = 'CORRIDOR_FORMULA_MAX',
    CORRIDOR_SCOPE = 'CORRIDOR_SCOPE',
    // Chaining
    CHAINING_NAME = 'CHAINING_NAME',
    CHAINING_ATTRIBUTE_ORDER = 'CHAINING_ATTRIBUTE_ORDER',
    CHAINING_GROUPS = 'CHAINING_GROUPS',
    CHAINING_ASSORTMENTS = 'CHAINING_ASSORTMENTS',
    CHAINING_PRICELISTS = 'CHAINING_PRICELISTS',
    // CPI Formulas
    CPI_FORMULA_NAME = 'CPI_FORMULA_NAME',
    CPI_FORMULA_ASSIGNMENT_CONTEXT = 'CPI_FORMULA_ASSIGNMENT_CONTEXT',
    CPI_CONTEXT_ASSIGNED_FORMULA = 'CPI_CONTEXT_ASSIGNED_FORMULA',
    // Prices view simulation
    PRICES_VIEW_SIMULATION_PRICE = 'PRICES_VIEW_SIMULATION_PRICE',
    PRICES_VIEW_SIMULATION_FLOAT = 'PRICES_VIEW_SIMULATION_FLOAT',
    STOCK = 'STOCK',
    COMPUTATION_STATUS = 'COMPUTATION_STATUS',
    AGREEMENT_AVAILABLE_STOCK = 'AGREEMENT_AVAILABLE_STOCK',
    TABLE = 'TABLE',
}

export enum RevenueColumn {
    REVENUE = 'REVENUE',
    REVENUE_PROJECTED = 'REVENUE_PROJECTED',
    REVENUE_VARIATION = 'REVENUE_VARIATION',
}

export const REVENUE_COLUMNS = [
    RevenueColumn.REVENUE,
    RevenueColumn.REVENUE_PROJECTED,
    RevenueColumn.REVENUE_VARIATION,
];

export const COLUMN_TYPE_ICON_MAP = {
    [ColumnType.INT]: '#',
    [ColumnType.FLOAT]: '#',
    [ColumnType.COST]: '#',
    [ColumnType.MARGIN]: '%',
    [ColumnType.PRICE]: '#',
    [ColumnType.ACTIVE_PRICE]: '#',
    [ColumnType.STR]: 'T',
    [ColumnType.DATETIME]: 'D',
    [ColumnType.DATE]: 'D',
    [ColumnType.BOOLEAN]: 'B',
    [ColumnType.BOOL]: 'B',
};

export const NUMERIC_COLUMN_TYPES = new Set([
    ColumnType.INT,
    ColumnType.BIGINT,
    ColumnType.FLOAT,
    ColumnType.PRICE,
    ColumnType.PRICES_VIEW_KPI_VOLUME,
    ColumnType.PRICES_VIEW_KPI_REVENUE,
    ColumnType.MARGIN,
    ColumnType.COST,
]);

export enum CompanyName {
    KILOUTOU = 'kiloutou',
    SELLER = 'seller',
    GBH = 'gbh',
    RENTACAR = 'rentacar',
    FRAIKIN = 'fraikin',
    MGF = 'mygreenfee',
    ADA = 'ada',
    CAJOO = 'cajoo',
    BMRENT = 'bmrent',
    EMPTY = 'empty',
    KILOUTOUISOPROD = 'kiloutouisoprod',
    TBC = 'tbc',
}

export const ALL_USERS_GROUP_NAME = 'all_users';

export const DEFAULT_ENGINE_TABLE_META: TableRawMeta = {};
